import React from "react";
import AtlassianBlockCard from "./cards/BlockCard";

const BlockDropZone = ({
  blocks,
  onReorder,
  onBlockClick,
  isEditMode = false,
  sectionIdx,
  sections,
  setSections,
  handleInsertBlock,
  handleDeleteBlock,
}) => {
  // Block drag-and-drop is intentionally disabled.
  const moveBlock = () => {};

  return (
    <div className={`block-drop-zone ${isEditMode ? "edit-mode" : ""}`}>
      {blocks.map((block, index) => (
        <AtlassianBlockCard
          key={block.id || index}
          block={block}
          index={index}
          sectionIdx={sectionIdx}
          blockIdx={index}
          sections={sections}
          setSections={setSections}
          isEditing={isEditMode}
          onClick={() => onBlockClick && onBlockClick(block)}
          moveBlock={moveBlock}
          totalItems={blocks.length}
          handleInsertBlock={handleInsertBlock}
          handleDeleteBlock={handleDeleteBlock}
        />
      ))}
    </div>
  );
};

export default BlockDropZone;
